define.alias("shared/components/shared/wizards/device-setup/step-two", "settings/components/shared/wizards/device-setup/step-two");